<div class="z-fx-col z-fx-gap-48 z-fx-auto">
  <div *ngIf="welcomeText == null" class="z-fx-col z-fx-gap-8">
    <ng-container *ngIf="!!inviteData?.email">
      <span class="zef-text-h2" i18n>{{ inviteData?.email }}</span>
      <span class="zef-text-p2-muted" i18n>Create new account</span>
    </ng-container>

    <ng-container *ngIf="!inviteData?.email">
      <span class="zef-text-h1" i18n>Create new account</span>
      <div class="z-fx z-fx-gap-8">
        <span class="zef-text-p2" i18n>Already have an account?</span>
        <a class="zef-text-p2 zef-hyper-link" (click)="changeMethod()" i18n>Sign In</a>
      </div>
    </ng-container>
  </div>

  <div *ngIf="welcomeText == null && !!inviteData" class="z-fx-col z-fx-gap-8">
    <team-tile
      variant="small"
      [teamName]="inviteData.teamName"
      [teamLogo]="inviteData.teamLogo"
      [teamCreated]="0"
    ></team-tile>

    <div *ngIf="!!inviteData?.userName" class="mat-typography">
      <p i18n>
        You were invited by
        <strong>{{ inviteData.userName }}</strong>
        to join their organization.
      </p>
    </div>
  </div>

  <div *ngIf="welcomeText != null" [innerHtml]="welcomeText | safeHtml" class="content"></div>
  <div *ngIf="!!inviteData; else noInvite" class="flex flex-col gap-16">
    <button
      mat-raised-button
      color="secondary"
      class="zef-stretch-button auth-provider-button"
      [disabled]="select | async"
      (click)="signUpWithGoogle()"
    >
      <div class="flex w-full items-center gap-8">
        <img [src]="'assets/logos/google.png'" alt="google" />
        <strong class="zef-text-p2 flex-auto" i18n>Sign up with Google</strong>
      </div>
    </button>

    <div *ngIf="googleError" class="zef-text-p1 error-text">
      {{ googleError }}
    </div>

    <button
      mat-raised-button
      color="secondary"
      class="zef-stretch-button auth-provider-button"
      [disabled]="select | async"
      (click)="signUpWithMicrosoft()"
    >
      <div class="flex w-full items-center gap-8">
        <img [src]="'assets/logos/microsoft.png'" alt="microsoft" />
        <strong class="zef-text-p2 flex-auto" i18n>Sign up with Microsoft</strong>
      </div>
    </button>

    <div *ngIf="microsoftError" class="zef-text-p1 error-text">
      {{ microsoftError }}
    </div>

    <div class="auth-or-divider">
      <hr />
      <span i18n>or</span>
      <hr />
    </div>

    <button
      mat-raised-button
      i18n
      color="ink"
      class="zef-stretch-button email-signup"
      [disabled]="select | async"
      (click)="signUpWithEmail()"
    >
      Create account with Email
    </button>

    <div *ngIf="emailError" class="zef-text-p1 error-text">
      {{ emailError }}
    </div>
  </div>
</div>

<ng-template #noInvite>
  <div class="zef-text-p2" i18n>
    To sign up, you'll need an invitation. Contact
    <!-- <span class="zef-text-p2-link">support&#64;zef.fi</span> -->
    <brand-email class="zef-text-p2-link" address="support"></brand-email>
    for more information.
  </div>
</ng-template>
